import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokSpecialPost.graphql';
import { Query, QuerytiktokSpecialPostArgs } from '../../__generated__/globalTypes';

export const useTiktokSpecialPostQuery = (options?: QueryHookOptions<Query, QuerytiktokSpecialPostArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokSpecialPostArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokSpecialPostLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokSpecialPostArgs>
): QueryResult<Query, QuerytiktokSpecialPostArgs> & {
  getTiktokSpecialPost: LazyQueryExecFunction<Query, QuerytiktokSpecialPostArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokSpecialPost, result] = useLazyQuery<Query, QuerytiktokSpecialPostArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokSpecialPost, ...result };
};

export const useTiktokSpecialPostPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokSpecialPost = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokSpecialPostArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokSpecialPostArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokSpecialPost };
};
// Suspense Query Hooks
export const useTiktokSpecialPostSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytiktokSpecialPostArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytiktokSpecialPostArgs>(QUERY, {
    ...options
  });

  return result;
};
